module.exports = __webpack_public_path__ + "static/media/photo300.be75cdbb.jpg";